import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular-pro';
import { OkAloneService } from '../../../ok-alone.service';

declare var require: any;
import moment from 'moment';

@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
})
export class DefaultFooterComponent extends FooterComponent {

  year;

  constructor(public okService:OkAloneService) {
    super();
    this.year = moment().format('YYYY');
  }
}
